import { Component, Input, signal } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { InstFormComponent } from '../inst-form/inst-form.component';
import { InstViewComponent } from '../inst-view/inst-view.component';
import { AuthService } from '../../../services/auth.service';
import { DataService } from '../../../services/data.service';
import { AlertConfirmService } from '../../../services/alert-confirm.service';

@Component({
	selector: 'app-inst-list',
	imports: [CommonModule, FormsModule, RouterLink, InstFormComponent, InstViewComponent],
	templateUrl: './inst-list.component.html',
	styleUrl: './inst-list.component.scss',
})
export class InstListComponent {
  @Input() user: any;
  @Input() action: any;
  
  base = 'institutes';		// important for API calls
  org_id: number = 0;
  btnClick: string = "";
  loading = false;
  isEdit = false;
  headers: any = null;
	myInst: any = signal<any>({});
  // orgs: any = [];
  selUser: any = {};
  allSchemas: any = null;
  modalOpen = false;

  constructor(
    public dataService: DataService, 
    private router: Router, 
    public auth: AuthService, 
    public alertService: AlertConfirmService, 
) {
    //
  }

  async ngOnInit() {
    if(!this.dataService.ddData) {
      await this.dataService.getDDData();
    }

    let erp_rem: any = localStorage.getItem("erp_rem");
    if(erp_rem && !this.user) {
      erp_rem = JSON.parse(erp_rem);
      erp_rem = this.dataService.deCodeUser(erp_rem);
      this.user = erp_rem;
    }

		this.loading = true;
    const old_erp_key = localStorage.getItem('erp_key');

    await this.dataService.getSingleRecord(this.base, old_erp_key || this.user.erp_key).then((res: any) => {
      if(res) {
        this.myInst.set(res.length ? res[0] : res);
        this.org_id = this.myInst()?.org_id;
      }

      this.loading = false;
    });

    // this.loading = true;
    // this.dataService.getAllRecords('organizations').then((res: any) => {
    //   this.orgs = res;
    //   this.loading = false;
    // });
	}

  ngOnChanges() {
		if(this.action && this.action=='reload') {
			this.ngOnInit();
		}
	}

  newClick() {
    this.isEdit = false;
    this.btnClick = 'addnew';
    this.dataService.updateOuterAction({
      component: 'institute',
      action: 'addnew', data: null
    });
  }

  editClick(myData: any) {
    this.isEdit = true;
    this.btnClick = 'modify';
    this.dataService.updateOuterAction({
      component: 'institute',
      action: 'edit', data: myData
    });
  }

  planClick(myData: any) {
    this.isEdit = false;
    this.btnClick = 'plan';
    this.dataService.updateOuterAction({
      component: 'institute',
      action: 'plan', data: myData
    });
    this.router.navigate(['/dashboard/'+this.dataService.myEncrypt('plan')]);
  }

  reloadData() {
    setTimeout(()=>{
      this.ngOnInit();
    }, 1000);
  }

	async deleteClick(myid: number) {
    const confirmed = await this.dataService.confirmDelete();
    if (confirmed) {
        console.log('Item deleted successfully');
				this.doDelete(myid);
    } else {
        console.log('Deletion cancelled');
    }
	}

  doDelete(myid: number) {
		this.loading = true;
    this.dataService.deleteRecord(this.base, myid).subscribe({
      next: (response) => {
        // console.log('Response received in component:', response);
        this.loading = false;
        this.ngOnInit();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
	}

  logout() { 
    this.alertService.confirm(
      'Logout?',
      'Are you sure you want to exit?',
      () => {
        this.auth.logout();
      },
      () => {
        //alert("No");
      },
      'primary'
    );
  }

}
